import { render, staticRenderFns } from "./settingView.vue?vue&type=template&id=602e36d2"
import script from "./settingView.vue?vue&type=script&lang=ts"
export * from "./settingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports